import React  from 'react';
import './styles/App.css';
import InventoryManager from './containers/InventoryManager/InventoryManager';

const app = () => <InventoryManager/>;

export default app;
